module.exports = __webpack_public_path__ + "static/media/Ysb.b3937591.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/campaign/Ysb.jpg
// module id = 1550
// module chunks = 0